// extracted by mini-css-extract-plugin
export default {"container":"Button_container__X9N6H","transparent":"Button_transparent__iMccj","text-7":"Button_text-7__0vfKf","pendingSkeleton":"Button_pendingSkeleton__mC08p"};